// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ELRJ","inner":"Footer_inner__3wRkU","nextIcon":"Footer_nextIcon__3QBaN","innerLeft":"Footer_innerLeft__3LB5E"};